import {
  TableRow,
  TableCell,
  Typography,
  Link,
  IconButton,
} from '@mui/material';
import { PaymentList } from 'containers/payments/PaymentType';
import { fDate } from 'utils/formatTime';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

type Props = {
  row: PaymentList;
};

export default function AccountBillingTableRow({ row }: Props) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { amount, created_at, invoice_pdf_link } = row;

  return (
    <TableRow aria-label='payment-row'>
      <TableCell>{fDate(Number(created_at))}</TableCell>
      <TableCell>
        <Typography variant='subtitle2' noWrap>
          ${amount}
        </Typography>
      </TableCell>
      <TableCell className='text-center'>
        <Link href={invoice_pdf_link} underline='none'>
          <IconButton
            aria-label='downloadInvoice'
            size='medium'
            className='hover:text-[#2196F3]'
          >
            <FileDownloadIcon fontSize='medium' />
          </IconButton>
        </Link>
      </TableCell>
    </TableRow>
  );
}
